import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { API_GET_ONE_CLIENT_RFP, apiGetOneClientRfp, } from '../../../../actions/ClientRfpActions';
import { propShape } from '../../../../helpers/custom-prop-types';
import { isLoading } from '../../../../helpers/fetch';
import { rfpOneUseCase } from '../One/UseCase/RfpOneUseCase';
/**
 * 案件詳細関連のHOC
 * @deprecated TS化+hook に移行: src/hooks/pages/rfp/useRfpClient.ts
 */
const ClientRfpHoc = (setting, ChildSkeletonComponent) => (ChildComponent) => {
    const ClientRfpHocInner = (props) => {
        const { redirectCallback } = setting;
        const { match } = props;
        const { params: { id }, } = match;
        const dispatch = useDispatch();
        const rfp = useSelector((state) => state.clientRfp.one[id]);
        const rfpLoading = useSelector((state) => isLoading(state, API_GET_ONE_CLIENT_RFP, id));
        const offers = rfpOneUseCase.useOffers(rfp);
        const redirect = useMemo(() => {
            if (rfpLoading === false && !rfp) {
                return '/mypage';
            }
            if (rfp && redirectCallback) {
                return redirectCallback({
                    match,
                    offers,
                    rfp,
                });
            }
            return '';
        }, [rfpLoading, redirectCallback, rfp, offers, match]);
        useEffect(() => {
            dispatch(apiGetOneClientRfp(id));
        }, [dispatch, id]);
        if (redirect) {
            return _jsx(CustomRedirect, { to: redirect });
        }
        if (!rfp) {
            return _jsx(ChildSkeletonComponent, {});
        }
        return (_jsx(ChildComponent, Object.assign({}, props, { offers: offers, rfp: rfp, rfpLoading: !!rfpLoading })));
    };
    ClientRfpHocInner.propTypes = {
        match: propShape().isRequired,
    };
    return ClientRfpHocInner;
};
export default ClientRfpHoc;
